var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollRightLarger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#D6E7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7 42.8998C25.4334 42.5665 25.2917 42.1998 25.275 41.7998C25.2584 41.3998 25.4 41.0498 25.7 40.7498L34.5 31.9498L25.65 23.0998C25.3834 22.8332 25.2584 22.4748 25.275 22.0248C25.2917 21.5748 25.4334 21.2165 25.7 20.9498C26.0334 20.6165 26.3917 20.4582 26.775 20.4748C27.1584 20.4915 27.5 20.6498 27.8 20.9498L37.75 30.8998C37.9167 31.0665 38.0334 31.2332 38.1 31.3998C38.1667 31.5665 38.2 31.7498 38.2 31.9498C38.2 32.1498 38.1667 32.3332 38.1 32.4998C38.0334 32.6665 37.9167 32.8332 37.75 32.9998L27.85 42.8998C27.55 43.1998 27.2 43.3415 26.8 43.3248C26.4 43.3082 26.0334 43.1665 25.7 42.8998Z",
    fill: "#1E2329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollRightLarger);
export default __webpack_public_path__ + "static/media/scroll-right-larger.b8fd9a9e.svg";
export { ForwardRef as ReactComponent };